// Figma "cases" > NS: section 55:728, frames 55:729 (cover), 55:794, 55:767, 55:820
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/ns/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own

export const ns: Case = {
    name: "NS",
    theme: {
        page: "#00163f",
        gradient: "linear-gradient(180deg, #00163f 0%, #00256e 100%)",
        stops: [
            [0, 22, 63, 0],
            [0, 37, 110, 1],
        ],
        fill: "#ffc917",
        line: "#246fff",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: {
                                logo: "/work/ns/logo.svg",
                                logoBox: [20, 26, 75, 28],
                                text: "NEDERLANDSE SPOORWEGEN\nRAILWAY OPERATOR\nFOUNDED 1938\n\nAPP",
                                ink: "#013082",
                            },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 663,
                    cells: [
                        { h: 623, image: IMG("1-1", 1326, 1246) },
                        {
                            h: 220,
                            w: 443,
                            end: true,
                            card: {
                                title: "Improving the\nway we travel",
                                body: "Multiple interactive UI elements created for NS, the Dutch railway company.",
                            },
                        },
                    ],
                },
                { w: 666, cells: [{ h: 846, image: IMG("1-2", 1332, 1692), phone: false }] },
            ],
        },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: IMG("2-1", 3114, 1692) }] }] },
        {
            type: "grid",
            columns: [
                { w: 776, cells: [{ h: 846, image: IMG("3-1", 1552, 1692) }] },
                {
                    w: 776,
                    cells: [
                        { h: 365, keep: true, image: IMG("3-2", 1552, 730) },
                        { h: 478, keep: true, image: IMG("3-3", 1552, 956) },
                    ],
                },
            ],
        },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: IMG("4-1", 3114, 1692) }] }] },
    ],
}
